// Удаление элементов с любым data-tags
export const removeDataTags = () => {
    const elementsWithDataTags = document.querySelectorAll('[data-tags]');
    elementsWithDataTags.forEach(element => {
        element.parentNode.removeChild(element);
    });
};

// add tags on DOM
export const appendTagsToElement = (htmlString, tagElement, position, dataAttributeValue) => {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const children = Array.from(tempContainer.childNodes);

    children.forEach(child => {
        if (child.nodeType !== Node.ELEMENT_NODE) return;

        // Функция для проверки, есть ли дубликат
        const isDuplicate = (newElem) => {
            return Array.from(tagElement.children).some(existing => {
                // Проверяем совпадение tagName
                if (existing.tagName !== newElem.tagName) return false;

                // Проверяем совпадение всех атрибутов
                const existingAttrs = Array.from(existing.attributes).map(a => [a.name, a.value]);
                const newAttrs = Array.from(newElem.attributes).map(a => [a.name, a.value]);
                if (existingAttrs.length !== newAttrs.length) return false;
                for (let i = 0; i < existingAttrs.length; i++) {
                    if (existingAttrs[i][0] !== newAttrs[i][0] || existingAttrs[i][1] !== newAttrs[i][1]) return false;
                }

                // Проверяем содержимое для <script> и <noscript> и других
                return existing.innerHTML === newElem.innerHTML;
            });
        };

        let newElement;

        // Handle <script> tags
        if (child.tagName === 'SCRIPT') {
            newElement = document.createElement('script');
            for (const {name, value} of child.attributes) {
                newElement.setAttribute(name, value);
            }
            if (child.textContent) {
                newElement.text = child.textContent;
            }
        }

        // Handle <noscript> tags
        else if (child.tagName === 'NOSCRIPT') {
            newElement = document.createElement('noscript');
            newElement.innerHTML = child.innerHTML;
            if (dataAttributeValue) {
                newElement.setAttribute('data-tags', dataAttributeValue);
            }
        }

        // Handle all other tags
        else {
            newElement = child.cloneNode(true);
            if (dataAttributeValue) {
                newElement.setAttribute('data-tags', dataAttributeValue);
            }
        }

        // add if not same
        if (!isDuplicate(newElement)) {
            if (position === 'top') {
                tagElement.insertBefore(newElement, tagElement.firstChild);
            } else {
                tagElement.appendChild(newElement);
            }
        }
    });
};


// tags for page
export const pageTags = (json) => {
    removeDataTags();
    const headTagString = json.headTags;
    const bodyTopTagString = json.bodyTopTags;
    const bodyBottomTagString = json.bodyBottomTags;

    if (headTagString) {
        appendTagsToElement(headTagString, document.head, null, 'page-tags');
    }
    if (bodyTopTagString) {
        appendTagsToElement(bodyTopTagString, document.body, 'top', 'page-tags');
    }
    if (bodyBottomTagString) {
        appendTagsToElement(bodyBottomTagString, document.body, null, 'page-tags');
    }
};

// tags for project
export const projectTags = (json) => {
    const projectTags = document.querySelectorAll('[data-tags="project-tag"]');
    if (!projectTags.length) {
        json.map(item => {
            if (item.positionType === 0) {
                const headTagStringAll = item.body;
                appendTagsToElement(headTagStringAll, document.head, null, 'project-tag');
            } else {
                const bodyTagStringAll = item.body;
                appendTagsToElement(bodyTagStringAll, document.body, null, 'project-tag');
            }
        });
    }
};

// Мета-теги для страницы
export const pageMetaTag = (json) => {
    const titleTag = document.querySelector('title');
    if (json?.title && titleTag) {
        titleTag.textContent = json.title;
    }

    const canonicalUrlTag = document.querySelector('link[rel="canonical"]');
    if (json?.canonicalUrl && canonicalUrlTag) {
        canonicalUrlTag.setAttribute('href', json.canonicalUrl);
    }
};

// Добавление произвольных мета-тегов
export const pageMetaTags = (json) => {

    removeDataTags();
    const headTagString = json.metatags;

    if (headTagString) {
        appendTagsToElement(headTagString, document.head, null, 'page-metaTags');
    }
};
